import type {
  FixedTimeRangeConfig,
  IntervalJSON,
} from '@highimpact-frontend/api-types';
import {
  getOverallTimeSpan,
  resolveIntervalToFixed,
} from '@highimpact/time-intervals';
import dayjs, { ManipulateType } from 'dayjs';

type RelativeTimeRangeUnion = Extract<
  IntervalJSON,
  { type: 'calendar_time_range' } | { type: 'relative_time_range' }
>;
type TimeUnit = RelativeTimeRangeUnion['unit'];

const unitMap: Record<TimeUnit, ManipulateType> = {
  millisecondes: 'millisecond',
  seconds: 'second',
  minutes: 'minute',
  hours: 'hour',
  days: 'day',
  weeks: 'week',
  months: 'month',
  years: 'year',
};

export const resolveInterval = resolveIntervalToFixed;

export const resolveIntervals = getOverallTimeSpan;

export function decreaseFirstInterval(
  intervals: IntervalJSON[],
  unit: TimeUnit,
  quantity: number
): FixedTimeRangeConfig | undefined {
  if (!Array.isArray(intervals) || intervals.length === 0) {
    return undefined;
  }

  const first = intervals[0];
  const resolvedOriginal = resolveInterval(first);
  const dayjsUnit = unitMap[unit];

  if (!dayjsUnit || first.type === 'fixed_time_range') {
    const resolved = resolveIntervals(intervals);
    return resolved
      ? {
          type: 'fixed_time_range',
          name: null,
          startdate: resolved[0],
          enddate: resolved[1],
        }
      : undefined;
  }

  const modifiedFirst: IntervalJSON = {
    ...first,
    unit,
    quantity,
  };

  const resolvedModified = resolveInterval(modifiedFirst);

  const originalDuration = dayjs(resolvedOriginal.enddate).diff(
    dayjs(resolvedOriginal.startdate)
  );
  const modifiedDuration = dayjs(resolvedModified.enddate).diff(
    dayjs(resolvedModified.startdate)
  );

  const nextIntervals =
    modifiedDuration <= originalDuration
      ? [modifiedFirst, ...intervals.slice(1)]
      : intervals;

  const resolved = resolveIntervals(nextIntervals);

  return resolved
    ? {
        type: 'fixed_time_range',
        name: null,
        startdate: resolved[0],
        enddate: resolved[1],
      }
    : undefined;
}
